<div layout="column" layout-align="center center" layout-padding>
<h1>{{'SERVER_NOT_FOUND' | translate}}</h1>
<h3>{{'TRY_AGAIN' | translate}}</h3>
</div>
